module.exports = __webpack_public_path__ + "static/media/poster3.eb6a0aa8.jpg";